module.exports = __webpack_public_path__ + "static/media/light-theme-stop-duration.5310441c.svg";